<template>
  <footer class="footer">
    <section class="footer__contact">
      <h4 class="footer__contact__title">
        Para consultas y solicitudes, contáctanos en:
      </h4>
      <p class="footer__contact__content">
        Avenida Rómulo Betancourt No. 297 Plaza Madelta III, <br />
        Local 404. Bella Vista. Santo Domingo. República Dominicana. <br />
        (809)532-7566 | info@torbel.do
      </p>
      <a
        href="https://api.whatsapp.com/send?phone=18297623396&text=Para consultas y solicitudes, contáctanos."
        target="_blank"
        class="btn btn-success whatsapp-btn footer__contact__action"
      >
        <i class="icon fab fa-whatsapp"></i>
        <span>Contacto WhatsApp</span>
      </a>
    </section>

    <section class="footer__site-map p-5">
      <div class="footer__site-map__logo">
        <img
          src="../../assets/images/logo-torbel-narvbar-fix.svg"
          alt="Logo Torbel"
        />
      </div>

      <div class="footer__site-map__list">
        <h6>Secciones</h6>
        <router-link :to="{ name: 'home' }">
          Inicio
        </router-link>

        <router-link :to="{ name: 'empresa' }">
          La empresa
        </router-link>

        <router-link :to="{ name: 'proyectos' }">
          Proyectos
        </router-link>

        <router-link :to="{ name: 'linea-servicio' }">
          Linea de servicios
        </router-link>
      </div>

      <div class="footer__site-map__list">
        <router-link :to="{ name: 'clientes' }">
          Clientes
        </router-link>
        <router-link :to="{ name: 'linea-servicio' }">
          Gestion ambiental
        </router-link>
        <router-link :to="{ name: 'empresa' }">
          Responsabilidad social
        </router-link>
        <router-link :to="{ name: 'empresa' }">
          Conoce el equipo
        </router-link>
      </div>

      <div class="footer__site-map__social-networks">
        <h6>Síguenos en</h6>
        <div>
          <a
            href="https://www.facebook.com/Torbel-SRL-1781222338771029/"
            target="_blank"
          >
            <i class="icon fab fa-facebook-square"></i>
          </a>
          <a href="https://www.instagram.com/torbelrd/" target="_blank">
            <i class="icon fab fa-instagram"></i>
          </a>
        </div>
      </div>
    </section>

    <section class="footer__copyright p-4">
      <span
        >Torbel - Todos los derechos reservados
        {{ new Date().getFullYear() }}
      </span>
      <a href="https://mctekk.com/" class="footer__copyright__made-by">
        Desarrollado por
        <img
          src="../../assets/images/mctekk-logo.png"
          class="footer__copyright__logo"
          alt="Mctekk logo"
        />
      </a>
    </section>
    <a
      href="https://api.whatsapp.com/send?phone=18297623396&text=Para consultas y solicitudes, contáctanos."
      target="_blank"
      class="whatsapp-btn float-cta"
    >
      <i class="icon fab fa-whatsapp"></i>
    </a>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
};
</script>

<style lang="scss" scoped>
.footer {
  &__contact {
    @extend %flex__align-center;
    flex-direction: column;
    padding: 80px 30px;
    border-top: 1px solid #e9ecefc7;
    text-align: center;

    &__title {
      color: $primary-color;

      @media (max-width: 359px) {
        font-size: 22px;
      }
    }

    &__content {
      line-height: 28px;
      margin: 10px 0;
    }

    &__action {
      display: flex;
      justify-content: center;
      align-items: center;
      color: white;

      .icon {
        font-size: 30px;
        vertical-align: middle;
        margin-right: 10px;

        a {
          color: $white !important;
        }
      }
    }
  }

  &__site-map {
    display: flex;
    justify-content: space-around;
    font-size: $small-font-size;

    border-top: 1px solid #e9ecefc7;

    @media (max-width: 767px) {
      flex-wrap: wrap;
      justify-content: flex-start;
    }

    @media (max-width: 549px) {
      flex-direction: column;
      text-align: center;
    }

    a {
      font-size: $extra-small-font-size;
      &:hover {
        text-decoration: none;
        color: $light--blue;
      }
    }

    &__logo {
      width: 200px;

      @media (max-width: 767px) {
        flex-basis: 100%;
        margin: 20px 0;
      }

      @media (max-width: 549px) {
        flex-basis: 100%;
        margin-top: 20px;
        width: 100%;
      }
    }

    &__list {
      display: flex;
      flex-direction: column;

      &:first-of-type {
        background-color: red;
      }

      @media (max-width: 767px) {
        flex: 1;
      }
    }

    &__social-networks {
      .icon {
        font-size: $subtitle-font-size;
        margin-right: 10px;
      }

      @media (max-width: 549px) {
        margin-top: 20px;
      }
    }
  }

  &__copyright {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: $bg-blue;
    font-size: $extra-font-size;
    color: $white;

    @media (max-width: 549px) {
      flex-direction: column;
    }

    a {
      font-size: $extra-font-size;
      color: $white;
    }

    &__made-by {
      display: flex;
      align-items: center;
    }

    &__logo {
      max-width: 98px;
      max-height: 18px;
      margin: 0 5px;

      @media (max-width: 549px) {
        margin: 10px 5px;
      }
    }
  }
}

.whatsapp-btn {
  background-color: #25d366;
  transition: background 0.5s;
  border-color: #25d366;
  color: $white;

  &:hover {
    background-color: #128c7e;
    border-color: #128c7e;
    color: $white;
  }
}

.float-cta {
  position: fixed;
  z-index: 1000;
  bottom: 80px;
  right: 4%;
  font-size: 2rem;
  border-radius: 100%;
  text-align: center;
  padding: 5px 15px;

  @media (max-width: 767px) {
    bottom: 72px;
  }
}
</style>
